import { render } from "./Download.vue?vue&type=template&id=020e182c&scoped=true"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"

import "./Download.vue?vue&type=style&index=0&id=020e182c&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Tenisu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020e182c"]])

export default __exports__